import React from 'react';
export function SocialProof() {
  return <section className="py-24 bg-brand-cream" data-id="element-107">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-108">
        <div className="text-center mb-12" data-id="element-109">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-brown mb-4" data-id="element-110">
            ¿Qué cambia en 7 días?
          </h2>
        </div>

        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-xl relative overflow-hidden" data-id="element-111">
          {/* Decorative quote mark */}
          <div className="absolute top-4 left-8 text-9xl text-brand-yellow/20 font-heading leading-none select-none" data-id="element-112">
            "
          </div>

          <div className="relative z-10" data-id="element-113">
            <p className="text-xl md:text-2xl text-brand-brown/90 leading-relaxed font-medium mb-8" data-id="element-114">
              El primer domingo después de tener este plan,{' '}
              <span className="text-brand-coral font-bold bg-brand-coral/10 px-2 py-1 rounded" data-id="element-115">
                cerrarás la puerta de la cocina a las 8:15 PM
              </span>{' '}
              con todo listo.
            </p>

            <p className="text-xl md:text-2xl text-brand-brown/90 leading-relaxed font-medium mb-8" data-id="element-116">
              El lunes por la mañana,{' '}
              <span className="text-brand-teal font-bold bg-brand-teal/10 px-2 py-1 rounded" data-id="element-117">
                no habrá gritos por comida
              </span>{' '}
              y tus hijos abrirán su Bento Box con la emoción de quien recibe un
              regalo, no un trámite.
            </p>

            <div className="flex items-center gap-4 mt-8 pt-8 border-t border-brand-brown/10" data-id="element-118">
              <div className="w-12 h-12 bg-brand-coral/20 rounded-full flex items-center justify-center text-brand-coral font-bold text-xl" data-id="element-119">
                M
              </div>
              <div data-id="element-120">
                <p className="font-bold text-brand-brown" data-id="element-121">
                  La realidad de cientos de mamás
                </p>
                <p className="text-sm text-brand-brown/60" data-id="element-122">
                  Que ya recuperaron sus mañanas
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}